import { render, staticRenderFns } from "./AppIndexAndPrevalenceAnalysisTable.vue?vue&type=template&id=671d0e54&scoped=true&"
import script from "./AppIndexAndPrevalenceAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./AppIndexAndPrevalenceAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./AppIndexAndPrevalenceAnalysisTable.vue?vue&type=style&index=0&id=671d0e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d0e54",
  null
  
)

export default component.exports